/**
 * Header — sombra/blur ao rolar.
 * Adiciona `.scrolled` quando scrollY > 24.
 */

const SCROLL_THRESHOLD = 24;
const HEADER_ID = 'siteHeader';

export function initHeader(): () => void {
  const header = document.getElementById(HEADER_ID);
  if (!header) return () => {};

  const apply = (): void => {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  apply();
  window.addEventListener('scroll', apply, { passive: true });

  return () => {
    window.removeEventListener('scroll', apply);
  };
}
